"use client";

import { useEnsurePHPSESSIDCookie } from "../../hooks/useEnsurePHPSESSIDCookie.hook";

/**
 * Mount-only client component that fires the PHPSESSID sync via React Query.
 * Renders nothing — the side effect is the cookie write performed by the
 * underlying Server Action.
 */
export function EnsurePHPSESSIDCookieSync() {
  useEnsurePHPSESSIDCookie();
  return null;
}
